import styled from 'styled-components';
import DetailBox from './DetailBox'
import Entrepreneurial_Festival from '../../assets/img/Events/event-card.png' 


function EntrepreneurialFestival() {
  return (
    <Container>
        <DetailBox title='Entrepreneurial Festival'
                    details={<>
                    Entrepreneurial Festival is another opportunity for the masses who are looking to do something different. It is a positive thing to be involved in this project, and we’re always looking for new ways of making our community even bigger. Entrepreneurs have more opportunities than ever before to meet with their mentors and other people involved directly or indirectly. Some are even invited to speak publicly about their company at length afterwards.
                    </>}
                    highlight='Event Highlights:'
                    list1='STARTUP ACADEMY LAUNCH EVENT'
                    list2='STARTUP CONTEST'
                    list3='MOU Signing Ceremony'
                    list4='Brand Ambassador Announcement'
                    list5='Accolades Ceremonies'
                    list6='Women Entrepreneurship in Nepal'
                    list7='Business Networking'
                    image={Entrepreneurial_Festival}
        />
      </Container>
  )
}

export default EntrepreneurialFestival
const Container = styled.div ` 

`